import { render } from "./QuizQuestionOptionFormBlock.vue?vue&type=template&id=5fd688a6"
import script from "./QuizQuestionOptionFormBlock.vue?vue&type=script&lang=js"
export * from "./QuizQuestionOptionFormBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__